module.exports = __webpack_public_path__ + "008f7ea65fcd96af1b087992f6164561.pdf";